export * from './accepts-new-patients-validation';
export * from './actively-treating-patients-validation';
export * from './address-validation';
export * from './disciplinary-action-validation';
export * from './fax-number-validation';
export * from './phone-number-validation';
export * from './specialty-validation';
